import notification from "antd/es/notification";
import { defineMessage, IntlShape } from "react-intl";

const message = defineMessage({
  id: "settings.saveSettingSuccessfulMessage",
  defaultMessage: "Settings successfully changed",
  description: "Settings save setting successful message",
});

const showSaveSettingSuccessfulMessage = (intl: IntlShape) =>
  notification.success({
    message: intl.formatMessage(message),
  });

export default showSaveSettingSuccessfulMessage;
